<template>
  <collapsible-box
    class="guide"
    :title="guide.heading"
    :content="guide.description"
    :collapsed="guide.collapsed"
    @close="$emit('close', guide.id)"
    @open="$emit('open', guide.id)"
  >
    <template>
      <video-embedded
        v-if="showVideo"
        :url="guide.videoUrl"
      ></video-embedded>
    </template>
    <div v-if="Object.keys(checklist).length" class="mtl">
      <div
        v-for="item in checklist"
        :key="item.id"
        :class="['checklist-item', { checked: isItemChecked(item.id) }]"
      >
        <div class="checkbox styled">
          <input
            :id="'item-checklist-' + item.id"
            type="checkbox"
            :checked="item.checked"
            @change="e => checklistItemChanged(item.id, e.target.checked)"
          />
          <label :for="'item-checklist-' + item.id" v-html="item.body" />
        </div>
      </div>
      <a
        v-if="anyItemIsChecked"
        href="javascript:;"
        class="reset-guide"
        @click="resetGuide()"
        >{{ this.resetGuideText }}</a
      >
    </div>
  </collapsible-box>
</template>

<script>
import CollapsibleBox from '../Shared/CollapsibleBox';
import VideoEmbedded from '../Video/VideoEmbedded';

export default {
  components: { CollapsibleBox, VideoEmbedded },
  props: {
    guide: {
      type: Object,
      required: true
    },
    resetGuideText: {
      type: String,
      required: true
    },
    videoUrl: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      checklist: this.guide.checklist
    };
  },
  computed: {
    id() {
      return this.guide.id;
    },
    anyItemIsChecked() {
      return Object.values(this.checklist).reduce(
        (acc, item) => acc || item.checked,
        false
      );
    },
    showVideo() {
      return !!this.guide.videoUrl;
    }
  },
  methods: {
    checklistItemChanged(checklistItemId, isChecked) {
      this.checklist[checklistItemId].checked = isChecked;
      this.$emit('checklistCheck', this.id, checklistItemId, isChecked);
    },
    isItemChecked(itemId) {
      return this.checklist[itemId].checked;
    },
    resetGuide() {
      Object.values(this.checklist).forEach(item => {
        item.checked = false;
      });
      this.$emit('guideReset', this.id);
    }
  }
};
</script>

<style>
.guide .box-content {
  padding: 0 0 12px;
}

.guide .video-wrapper {
  margin-top: 0;
}

.guide .checklist-item.checked,
.guide .checklist-item.checked a {
  color: #bbb;
}

.guide .checklist-item.checked .checkbox label::before {
  border-color: #bbb;
}

.guide .checklist-item.checked .checkbox label::after {
  color: #bbb;
}

.reset-guide {
  display: inline-block;
  width: 100%;
  text-align: right;
}
</style>
